export const EXPERIMENTS = Object.freeze({
  visitor_trial_end_coupon_experiment: {
    premium_coupon_set: 'test20',
    premium_coupon_percentage: 20,
    standard_coupon_set: 'test15',
    standard_coupon_percentage: 15,
  },
});
